import { FC, useState } from 'react';

import { useChat } from '@/features/vfo/hooks/useChat';
import { useModalsStore } from '@/widgets/modals/modals.store';
import { VfoChatModalProps } from '@/widgets/modals/types';

import { ChatBody } from './ChatBody';
import { ChatSidebar } from './ChatSidebar';
import { Container, StyledDrawer } from './styled';

export const VfoChatModal: FC<VfoChatModalProps> = () => {
  const modals = useModalsStore();
  const [mobileView, setMobileView] = useState<'sidebar' | 'chat'>('sidebar');

  const { activeChatId, selectChat } = useChat();

  const handleClose = () => {
    modals.closeModal();
  };

  const handleChatSelect = (selectedChatId: string) => {
    selectChat(selectedChatId);
    setMobileView('chat');
  };

  return (
    <StyledDrawer
      width="max(1200px, 90%)"
      open={true}
      closable={false}
      footer={null}
      onClose={handleClose}
    >
      <Container>
        <ChatSidebar mobileView={mobileView} onChatSelect={handleChatSelect} />
        <ChatBody
          mobileView={mobileView}
          onBack={() => setMobileView('sidebar')}
          chatId={activeChatId}
          onClose={handleClose}
        />
      </Container>
    </StyledDrawer>
  );
};
